import * as React from 'react';
export const SelectRootContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") SelectRootContext.displayName = "SelectRootContext";
export const SelectFloatingContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") SelectFloatingContext.displayName = "SelectFloatingContext";
export function useSelectRootContext() {
  const context = React.useContext(SelectRootContext);
  if (context === null) {
    throw new Error('Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>.');
  }
  return context;
}
export function useSelectFloatingContext() {
  const context = React.useContext(SelectFloatingContext);
  if (context === null) {
    throw new Error('Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>.');
  }
  return context;
}